const ITEM_PROMOTIONAL_BADGE = {
  new: {
    name: 'NEW',
  },
  recommendedByMembo: {
    name: 'RECOMMENDED_BY_MEMBO',
  },
  smallProducer: {
    name: 'SMALL_PRODUCER',
  },
  popularItem: {
    name: 'POPULAR_ITEM',
  },
  bbq: {
    name: 'BBQ',
  },
  christmas: {
    name: 'CHRISTMAS',
  },
};

export default ITEM_PROMOTIONAL_BADGE;
